import React from "react";
import { pluralize } from "@common/helpers/string";
import { InvoiceSource } from "@common/types/invoice";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { BreakableText } from "@design-system/BreakableText/BreakableText";

interface Props {
    filters: {
        accountIds?: number[];
        hasNoFinancialAccount?: boolean;
        invoiceSources?: InvoiceSource[];
    };
}

export const AccountsFilterLabel: React.FC<Props> = ({
    filters: { accountIds, hasNoFinancialAccount, invoiceSources },
}) => {
    const accounts = useFinancialAccounts();
    const numericCount = accountIds?.length ?? 0;
    const isKickSelected =
        invoiceSources?.includes(InvoiceSource.MANUAL) ?? false;

    if (hasNoFinancialAccount && !isKickSelected && numericCount === 0) {
        return <BreakableText text="No account" />;
    }

    if (isKickSelected && !hasNoFinancialAccount && numericCount === 0) {
        return <BreakableText text="Kick" />;
    }

    if (!hasNoFinancialAccount && !isKickSelected && numericCount === 1) {
        const selectedAccount = accounts.find(
            ({ id }) => id === accountIds?.[0],
        );
        return <BreakableText text={selectedAccount?.name ?? "Account"} />;
    }

    const totalCount =
        numericCount +
        (hasNoFinancialAccount ? 1 : 0) +
        (isKickSelected ? 1 : 0);

    return (
        <>
            {totalCount} {pluralize("Account", totalCount)}
        </>
    );
};
